<div class="modal-body">
  <div class="row mb-32">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <p class="header-text poppins">CREATE SEASON</p>
      <img src="assets/img/shared/close-icon.svg" class="close-icon pointer" alt="" (click)="close()">
    </div>
    <div class="col-12">
      <p class="sub-text">Enter season details</p>
    </div>
  </div>

  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input matInput formControlName="season">
          <mat-label>Season name</mat-label>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input matInput [matDatepicker]="pickerStart" placeholder="Start Date" formControlName="seasonStart" [min]="dateToday" readonly>
          <mat-label>Start Date</mat-label>
          <mat-datepicker-toggle matSuffix [for]="pickerStart">
            <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input matInput [matDatepicker]="pickerEnd" placeholder="End Date" formControlName="seasonEnd" [min]="dateToday" readonly>
          <mat-label>End Date</mat-label>
          <mat-datepicker-toggle matSuffix [for]="pickerEnd">
            <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="active">Active</mat-option>
            <mat-option value="inactive">Inactive</mat-option>
          </mat-select>
        </mat-form-field>      
      </div>
    </div>

    <div class="row">
      <div class="col-12 ">
        <button class="btn create poppins" type="button" (click)="createSeason()" [disabled]="!form.valid">CREATE</button>  
      </div>
    </div>
  </form>
</div>
